import { render, staticRenderFns } from "./AppGebruikerGegevens.vue?vue&type=template&id=3b95208c&"
import script from "./AppGebruikerGegevens.vue?vue&type=script&lang=ts&"
export * from "./AppGebruikerGegevens.vue?vue&type=script&lang=ts&"
import style0 from "./AppGebruikerGegevens.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports